import $ from "jquery";
import axios from "axios";

const url = '/rest/profile/disable-device';

export const disableAvailableDevice = () => {
    $(document).on('click', '.available-device__btn', function () {
        send([$(this).children('button').data('id')]);
    });

    $(document).on('click', '.available-devices__button', function () {
        const deviceList = [];

        $('.active-available-device').each(function () {
            deviceList.push($(this).data('id'));
        });

        send(deviceList);
    })
};

const send = (deviceList) => {
    axios.post(url, {deviseIdList: deviceList}).then(function () {
        for (const i in deviceList) {
            const availableDeviceBlock = $('button[data-id=' + deviceList[i] + ']').parents('.available-device');

            availableDeviceBlock.remove();
        }
    });
};
